<template>
    <div>
        <b-row v-if="permissions.includes('procurement-purchase-inquiry')">
            <!-- card collapsible  -->
            <b-col md="12">
                <b-card-actions
                title="Filter"
                :collapsed="true"
                action-collapse
                >
                    <b-row>
                        <b-col md="3">
                            <b-form-group
                            label="Vendor"
                            label-for="vendor"
                            >
                                <b-form-select
                                id="vendor"
                                v-model="filter.selectedVendor"
                                :options="filter.optionsVendor"
                                />
                                <!-- Selected: <strong>{{ filter.selectedVendor }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group
                            label="Code"
                            label-for="code"
                            >
                            <b-form-input
                                id="code"
                                placeholder="Code"
                                v-model="filter.code"
                                required
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Start Date"
                            label-for="start_date"
                            >
                                <flat-pickr
                                id="start_date"
                                v-model="filter.start_date"
                                class="form-control"
                                :config="{ dateFormat: 'Y-m-d'}"
                                placeholder="Start Date"
                                />
                                <!-- <p>Value: '{{ filter.start_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="End Date"
                            label-for="end_date"
                            >
                                <flat-pickr
                                id="end_date"
                                v-model="filter.end_date"
                                class="form-control"
                                :config="{ dateFormat: 'Y-m-d'}"
                                placeholder="End Date"
                                />
                                <!-- <p>Value: '{{ filter.end_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Status"
                            label-for="status"
                            >
                                <b-form-select
                                id="status"
                                v-model="filter.selectedStatus"
                                :options="filter.optionsStatus"
                                />
                                <!-- Selected: <strong>{{ filter.selectedStatus }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mt-1"
                            @click="getInquiry(1, filter.selectedVendor, filter.code, filter.start_date, filter.end_date, filter.selectedStatus)"
                            >
                            Search
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-actions>
            </b-col>
        </b-row>
        <b-row v-if="permissions.includes('procurement-purchase-create')">
            <b-col class="text-right mb-1">
                <router-link to="/procurement/purchase/add">
                    <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="primary"
                    pill
                    class="px-3"
                    >
                    Add Purchase
                    </b-button>
                </router-link>
            </b-col>
        </b-row>
        <b-card v-if="permissions.includes('procurement-purchase-inquiry')">
            <!-- search input -->
            <!-- <b-row>
                <b-col class="custom-search d-flex justify-content-end">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <b-form-input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block"
                            />
                        </div>
                    </b-form-group>
                </b-col>
            </b-row> -->

            <!-- table -->
            <vue-good-table
            :columns="columns"
            :rows="rows"
            :rtl="direction"
            :search-options="{
                enabled: true,
                externalQuery: searchTerm 
            }"
            :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"
            :pagination-options="{
                enabled: true,
                perPage:pageLength
            }"
            >
                <template
                    slot="table-row"
                    slot-scope="props"
                >

                    <!-- Column: Name -->
                    <span
                    v-if="props.column.field === 'name'"
                    class="text-nowrap"
                    >
                        <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Total Price -->
                    <span
                    v-else-if="props.column.field === 'total_price'"
                    class="text-nowrap"
                    >
                        <span class="text-nowrap">{{ formatRupiah(props.row.total_price) }}</span>
                    </span>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'status'">
                        <b-badge :variant="statusVariant(props.row.status)">
                            <span v-if="props.row.status === 0">{{ props.row.status_name }}</span>
                            <span v-else-if="props.row.status === 1">{{ props.row.status_name }}</span>
                            <span v-else-if="props.row.status === 2">{{ props.row.status_name }}</span>
                            <span v-else-if="props.row.status === 3">{{ props.row.status_name }}</span>
                            <span v-else-if="props.row.status === 4">{{ props.row.status_name }}</span>
                        </b-badge>
                    </span>

                    <!-- Column: Order At -->
                    <span
                    v-else-if="props.column.field === 'created_at'"
                    class="text-nowrap"
                    >
                        <span class="text-nowrap">{{ moment(props.row.created_at) }}</span>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                        <span>
                            <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            >
                                <template v-slot:button-content>
                                    <feather-icon
                                    icon="MoreVerticalIcon"
                                    size="16"
                                    class="text-body align-middle mr-25"
                                    />
                                </template>
                                <b-dropdown-item v-bind:to="{path: '/procurement/purchase/' +props.row.id}" v-if="permissions.includes('procurement-purchase-detail')">
                                    <feather-icon
                                    icon="Edit2Icon"
                                    class="mr-50"
                                    />
                                    <span>Detail</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="submitStatus(props.row.id)" v-if="permissions.includes('procurement-purchase-update') && props.row.status === 0">
                                    <feather-icon
                                    icon="CheckCircleIcon"
                                    class="mr-50"
                                    />
                                    <span>Submit</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="deletePurchase(props.row.id)" v-if="permissions.includes('procurement-purchase-delete') && props.row.status <= 0">
                                    <feather-icon
                                    icon="TrashIcon"
                                    class="mr-50"
                                    />
                                    <span>Delete</span>
                                </b-dropdown-item>
                                <b-dropdown-item v-b-modal.modal-process @click="triggerID(props.row.id)" v-if="permissions.includes('procurement-purchase-update') && props.row.status === 1">
                                    <feather-icon
                                    icon="CheckCircleIcon"
                                    class="mr-50"
                                    />
                                    <span>Process</span>
                                </b-dropdown-item>
                                <b-dropdown-item @click="statusReceive(props.row.id)" v-if="permissions.includes('procurement-purchase-update') && props.row.status === 2">
                                    <feather-icon
                                    icon="CheckCircleIcon"
                                    class="mr-50"
                                    />
                                    <span>Receive</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>

                <!-- pagination -->
                <template
                    slot="pagination-bottom"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap ">
                            Showing {{ meta.from }} to {{ meta.to }}
                            </span>
                            <span class="text-nowrap">&nbsp;of {{ meta.total }} entries </span>
                        </div>
                        <div>
                            <b-pagination
                            :value="1"
                            :total-rows="meta.total"
                            :per-page="meta.per_page"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mt-1 mb-0"
                            @input="(value)=>getInquiry(value, filter.selectedVendor, filter.code, filter.start_date, filter.end_date, filter.selectedStatus)"
                            >
                            <template #prev-text>
                                <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                                />
                            </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </b-card>
        <!-- Modal -->
        <b-modal
        id="modal-process"
        hide-footer
        centered
        size="md"
        title="Large Modal"
        no-close-on-backdrop
        >
            <b-row>
                <b-col md="12">
                    <b-form-group
                    label="Amount"
                    label-for="amount"
                    >
                    <cleave
                        id="amount"
                        placeholder="Amount"
                        v-model="process.amount"
                        class="form-control border-secondary"
                        :raw="false"
                        :options="options.number"
                        required
                    />
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group
                    label="Term Payment"
                    label-for="term_payment"
                    >
                        <v-select
                        id="term_payment"
                        class="border border-secondary rounded"
                        v-model="process.selectedTermPayment"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="text"
                        :options="process.optionsTermPayment"
                        placeholder="Select 1 Term Payment"
                        required
                        >
                            <template #search="{attributes, events}">
                                <input
                                class="vs__search"
                                :required="!process.selectedTermPayment"
                                v-bind="attributes"
                                v-on="events"
                                />
                            </template>
                        </v-select>
                        <!-- Selected: <strong>{{ process.selectedTermPayment }}</strong> -->
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button
                        class="mt-2"
                        type="submit"
                        variant="primary"
                        block
                        @click="checkProcess()"
                    >
                        Process
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import {
    BForm, BFormFile, BModal, VBModal, BButton, BRow, BCol, BCard, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'

export default {
    components: {
        BCardActions,
        VueGoodTable,
        ToastificationContent,
        flatPickr,
        vSelect,
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BForm,
        BFormFile,
        BModal,
        BButton,
        BRow,
        BCol,
        BCard, 
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [
                {
                    label: 'Code',
                    field: 'code',
                },
                {
                    label: 'Vendor',
                    field: 'vendor_name',
                },
                {
                    label: 'Total Price',
                    field: 'total_price',
                },
                {
                    label: 'Date',
                    field: 'created_at',
                },
                {
                    label: 'Status',
                    field: 'status',
                },
                {
                    label: 'Action',
                    field: 'action',
                    width: '100px'
                },
            ],
            filter: {
                selectedVendor: '',
                optionsVendor: [],
                code: '',
                selectedStatus: '',
                optionsStatus: [
                    {value: '', text: 'All'},
                    {value: 0, text: 'Pending'},
                    {value: 1, text: 'Waiting Payment'},
                    {value: 2, text: 'Ordered'},
                    {value: 3, text: 'Received'},
                    {value: 4, text: 'Canceled'}
                ],
                start_date: '',
                end_date: ''
            },
            process: {
                id: null,
                amount: null,
                selectedTermPayment: null,
                optionsTermPayment: []
            },
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            search: '',
            rows: [],
            searchTerm: '',
            meta: {
                current_page: 1,
                last_page: 0,
                from: 0,
                to: 0,
                per_page: 10,
                total: 0,
            },
            permissions: [],
            errors: '',
            errMessage: '',
            file: null
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                0 : 'light-warning',
                1 : 'light-info',
                2 : 'light-primary',
                3 : 'light-success'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        this.getAllPermissions()
        this.getInquiry(1, "", "", "", "", "")
        this.getVendor()
        this.getTermPayment()
    },
    methods: {
        moment(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        formatRupiah(money) {
            return new Intl.NumberFormat('id-ID',
                { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
            ).format(money);
        },
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        getInquiry($page, $vendor, $code, $start_date, $end_date, $status) {
            this.$http.get('procurement/purchases?page=' + $page + ($vendor ? "&vendor_id="+this.filter.selectedVendor : "" ) + ($code ? "&code="+this.filter.code : "" ) + ($start_date ? "&start_date="+this.filter.start_date : "" ) + ($end_date ? "&end_date="+this.filter.end_date : "" ) + ($status ? "&status="+this.filter.selectedStatus : "" ))
            .then(res => { 
                this.rows = res.data.data
                // console.log(res.data.data)
                var meta = res.data.meta
                if (meta.from != null) {
                    this.meta.from = meta.from
                }
                if (meta.to != null) {
                    this.meta.to = meta.to
                }
                this.meta.current_page = meta.current_page
                this.meta.last_page = meta.last_page
                this.meta.per_page = meta.per_page
                this.meta.total = meta.total
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            })
        },
        getVendor() {
            this.$http.get('procurement/vendors')
            .then(response => { 
                // console.log(response.data.data)
                this.filter.optionsVendor.push({value: '', text: 'All'})
                
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.filter.optionsVendor.push($data)
                }
                // console.log(this.filter.optionsVendor)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            })
        },
        getTermPayment() {
            this.$http.get('procurement/term-payments')
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.process.optionsTermPayment.push($data)
                }
                // console.log(this.process.optionsTermPayment)
            });
        },
        submitStatus(id) {
            this.$http
            .post("procurement/purchase/"+id+"/status", {
                status: 1
            })
            .then((response) => {
                // console.log(response.data.data)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Data has been submited',
                        variant: 'success',
                    },
                })
                location.href = "/procurement/purchase"
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
        triggerID($id) {
            this.process.id = $id
        },
        checkProcess() {
            if(this.process.amount === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Amount field is required',
                        variant: 'warning',
                    },
                })
            } else if(this.process.selectedTermPayment === null) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'The Term Payment field is required',
                        variant: 'warning',
                    },
                })
            } else {
                this.processPurchase()
            }
        },
        processPurchase() {
            var newAmount = this.process.amount
            newAmount = newAmount.replace(/\,/g,'')
            if(this.process.selectedTermPayment !== null) {
                var $termPayment = this.process.selectedTermPayment.value
            }
            this.$http
            .post("procurement/purchase/"+this.process.id+"/process", {
                amount: newAmount,
                term_payment: $termPayment
            })
            .then((response) => {
                // console.log(response.data.data)
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Purchase Processed',
                        variant: 'success',
                    },
                })
                location.href = "/procurement/purchase"
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
        statusReceive($id) {
            sessionStorage.setItem('purchaseID', $id)
            this.$router.push({name:'create-receiving', params: {'id': $id}})
        },
        deletePurchase($id) {
            this.$http
            .post("procurement/purchase/"+$id+"/delete")
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Purchase has been Deleted',
                        variant: 'danger',
                    },
                })
                location.href = "/procurement/purchase"
                console.log(response.data.data)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                console.log(errors.response)
            })
        },
    },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import "@core/scss/vue/libs/vue-good-table.scss";
@import '@core/scss/vue/libs/vue-select.scss';
</style>